<template>
  <div class="d-flex align-items-center justify-content-between">
    <!-- Left side with title -->
    <b-link
      style="font-size: 26px; color: #fff;"
      :to="{ path: `/vms-sub?DeptID=${deptid}`}"
    >
      <feather-icon
        style="margin-bottom: 5px;"
        size="34"
        icon="ArrowLeftIcon"
      /><span style="color: #00FF80;"> ป้าย VMS: </span>{{ waydetail }}
    </b-link>

    <!-- Right side with status and buttons -->
    <div class="d-flex align-items-center">
      <span
        class="mr-1"
        style="font-size:16px; height: 30px; min-width: 65px;"
      >
        <b-badge
          v-if="vms_connect === 'Online'"
          variant="light-success"
        >
          {{ vms_connect }}
        </b-badge>
        <b-badge
          v-if="vms_connect === 'Offline'"
          variant="light-danger"
        >
          {{ vms_connect }}
        </b-badge>
      </span>
      <a
        v-if="owner === 'psd'"
        class="mr-1"
        target="_blank"
        href="http://dorrayongcenter.dyndns.org:11080/"
      >
        <b-button
          size="sm"
          variant="outline-light"
        ><b-img
          src="@/assets/images/icons/Live.svg"
          style="height: 16px; width: 16px;"
        /> <span style="color:#fff;"> ระบบจัดการป้าย</span></b-button>
      </a>
      <a :href="anydesk">
        <b-button
          size="sm"
          variant="outline-danger"
        ><b-img
          src="@/assets/images/logo/anydesk.png"
          style="height: 16px; width: 16px;"
        /> <span style="color:#fff;"> {{ anydesk1 }}</span></b-button>
      </a>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BLink, BButton, BBadge, BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BLink,
    BButton,
    BBadge,
    BImg,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      waydetail: '',
      markers: [],
      camdesc: '',
      vms_connect: '',
      anydesk: '',
      anydesk1: '',
      deptid: '',
      owner: '',
    }
  },
  created() {
    this.getMarkerVMS()
  },
  mounted() {
  },
  methods: {
    getMarkerVMS() {
      axios
        .post('/getMarkerVMSDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.markers = response.data
          this.center = []
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
          this.waydetail = response.data[0].detail
          this.deptid = response.data[0].deptid
          this.vms_connect = response.data[0].vms_connect
          this.anydesk = `anydesk:${response.data[0].anydesk}`
          this.anydesk1 = response.data[0].anydesk
          this.owner = response.data[0].owner
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
